import React from 'react'
import BlueHeading from '../other/common/BlueHeading';
import Heading from '../common/ui/Heading';
const ArticleHero = () => {
  return (
    <>
      <div className="bg-articles-hero-bg bg-center bg-cover bg-no-repeat px-4">
        <div className="max-w-[861px] mx-auto py-[206px] max-xl:py-44 max-lg:py-32 max-md:py-24 max-sm:py-14">
          <div className="flex items-center justify-center flex-col">
            <BlueHeading
              lineClassOne="!bg-white"
              lineClassTwo="!bg-white"
              text="Thought Impact"
              textClass="!text-white"
            />
            <Heading
              children="Thoughts that flow from the pen bring change to society"
              className="text-white text-6xl text-center"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ArticleHero